import { ApolloClient, InMemoryCache, createHttpLink } from "@apollo/client";
import { setContext } from "@apollo/client/link/context";
import { TRIGGER_AD_AGENCY_JOB_MUTATION } from "../queries/libraryCardQueries";
import { getAuthToken } from "../utils/authUtils";

const GRAPHQL_ENDPOINT = "https://m2jxbyhagffjthxtsiuwb2iiwe.appsync-api.us-east-1.amazonaws.com/graphql";

const httpLink = createHttpLink({ uri: GRAPHQL_ENDPOINT });

const authLink = setContext((_, { headers }) => {
  const token = getAuthToken();
  return {
    headers: {
      ...headers,
      ...(token ? { Authorization: token } : {}),
    },
  };
});

const client = new ApolloClient({
  link: authLink.concat(httpLink),
  cache: new InMemoryCache(),
});

async function triggerJob(jobType, tenantId, payload = {}) {
  const { data } = await client.mutate({
    mutation:  TRIGGER_AD_AGENCY_JOB_MUTATION,
    variables: { input: { jobType, tenantId, payload: JSON.stringify(payload) } },
  });
  return data.triggerAdAgencyJob;
}

export const generateAdCreativeApi    = (payload) => triggerJob("GENERATE_AD_CREATIVE",       payload.tenantId, payload);
export const publishAdCreativeApi     = (payload) => triggerJob("PUBLISH_AD_CREATIVE",        payload.tenantId, payload);
export const triggerArtDeptApi        = (payload) => triggerJob("TRIGGER_ART_DEPT",           payload.tenantId, payload);
export const triggerAdVideoApi        = (payload) => triggerJob("TRIGGER_AD_VIDEO",           payload.tenantId, payload);
export const triggerGoogleAdsCampaignApi = (payload) => triggerJob("CREATE_GOOGLE_ADS_CAMPAIGN", payload.tenantId, payload);
export const publishGoogleAdApi       = (payload) => triggerJob("PUBLISH_GOOGLE_AD",          payload.tenantId, payload);
export const getGoogleAdStatusApi     = (payload) => triggerJob("GET_GOOGLE_AD_STATUS",       payload.tenantId, payload);
export const googleAdsOAuthCallbackApi = (payload) => triggerJob("GOOGLE_ADS_OAUTH_CALLBACK", payload.tenantId, payload);
